import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  OnDestroy,
  ViewChild,
  ViewContainerRef
} from '@angular/core';

import { DropdownComponent } from './dropdown.component';
import { isEquivalent } from '../utilities/utilities';

@Component({
  selector: 'axis-dropdown-list',
  templateUrl: './dropdownList.component.html',
  host: { '[attr.disabled]': 'disabled', class: 'axis-dropdown-list-item',
  '[attr.id]': 'ucid'
 }
})
export class DropdownListComponent implements AfterViewInit, OnDestroy {

  public childSelected = false;
  public componentRef;
  public isReadOnly = false;
  public isSelected = false;
  public isSelectOptionCalled = false;
  public renderViewFlag = false;
  public selectedValue = '';
  public ucid = '';

  @ContentChild('labelToRender', { static: true }) renderLabel: ElementRef;

  @Input() ariaLabel: string;
  @Input() axisIncludeComponent: any;
  @Input() disabled: any;
  @Input() option: any;
  @Input() renderingLabel: string;

  @Output() getSelectedValue = new EventEmitter();

  @ViewChild('contentWrapper', { static: true }) content: ElementRef;
  @ViewChild('listContainer', { static: true }) listContainer: ElementRef;

  constructor(
    public axisDropDownComponent: DropdownComponent,
    private changeDetectorRef: ChangeDetectorRef,
    private resolver: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef) {
    this.axisDropDownComponent.dropdownListArray.push(this);
    this.ucid = (Math.random() + Math.random()).toString().replace('.', '');
  }

  ngAfterViewInit() {
    if (!this.option) {
      let text: string;
      if (this.renderLabel) {
        text = this.renderLabel.nativeElement.textContent.trim();
      } else {
        text = this.content.nativeElement.textContent.trim();
      }
      this.option = {
        value: text,
        isSelected: false
      };
    } else {
      if (this.axisDropDownComponent.model) {
        if ((isEquivalent(this.axisDropDownComponent.model, this.option, 'isSelected'))) {
          this.isSelected = true;
        } else if (this.axisDropDownComponent.model === this.option['name']) {
          this.isSelected = true;
        }
        else {
          this.isSelected = false;
        }
      }
      this.isReadOnly = this.axisDropDownComponent.readonlyHeaders;
    }
    if (
      this.axisDropDownComponent.type !== 'radio' &&
      this.axisDropDownComponent.type !== 'multiSelect' &&
      !this.axisDropDownComponent.isObjectEnabled &&
      !this.axisDropDownComponent.isTypeahead
    ) {
      return;
    }
    if (this.content.nativeElement.remove) {
      this.content.nativeElement.remove();
    } else {
      this.content.nativeElement.parentNode.removeChild(
        this.content.nativeElement
      );
    }
    if (
      this.axisDropDownComponent.isNestedMultiselect &&
      this.option.children
    ) {
      // for nested dropdown
      this.initNestedChildObj();
    }
    this.renderViewFlag = true;
    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
    }
    setTimeout(() => {
      if (this.axisDropDownComponent.axisIncludeComponent) {
        const containerEl1 = this.listContainer.nativeElement.querySelector(
          '.dropdownIncludeTemplate'
        );
        const factory = this.resolver.resolveComponentFactory(
          this.axisDropDownComponent.axisIncludeComponent
        );
        this.componentRef = this.viewContainerRef.createComponent(factory);
        this.componentRef.instance.data = this.option;
        this.componentRef.instance.componentRef = this;
        containerEl1.appendChild(this.componentRef.location.nativeElement);
      }
    });
  }

  // Handles selection of item
  selectOption(event: Event) {
    this.isSelectOptionCalled = true;
    event.preventDefault();
    this.axisDropDownComponent.isListItem = true;

    setTimeout(() => {
      this.axisDropDownComponent.elRef.nativeElement.children[0].focus();
    }, 0);

    if (!this.disabled) {
      if (this.axisDropDownComponent.type !== 'multiSelect') {
        this.isSelected = true;
        this.option.isSelected = true;
        this.axisDropDownComponent.deSelectOthers(this);
      } else {
        this.isSelected = !this.isSelected;
        this.option.isSelected = this.isSelected;
        if (this.axisDropDownComponent.isNestedMultiselect) {
          this.selectNestedOptions(this.isSelected);
        }
      }
      this.axisDropDownComponent.notifyChange(this);
    }
  }

  selectOptionOnKeyDown(event: Event) {
    const key = event['key'].toLocaleLowerCase();
    if (!this.disabled) {
      this.axisDropDownComponent.isListItem = true;
      if (key === 'tab' && !this.axisDropDownComponent.isNestedMultiselect) {
        this.axisDropDownComponent.elRef.nativeElement.children[0].focus();
        this.axisDropDownComponent.notifyChange(this);
      } else if (key === 'enter' || key === 'space' || key === ' ') {
        setTimeout(() => {
          if (this.axisDropDownComponent.type !== 'multiSelect' && !this.axisDropDownComponent.isMultiSearchSelect) {
            this.axisDropDownComponent.elRef.nativeElement.children[0].focus();
          } else if (this.axisDropDownComponent.isMultiSearchSelect) {
            this.axisDropDownComponent.elRef.nativeElement.querySelector('#ddFilter' + this.axisDropDownComponent.ucid).focus();
            this.axisDropDownComponent.elementIndex = -1; // after selection, reset first arrowdown to -1
          }
        }, 0);
        event.preventDefault();
        event.stopPropagation();
        if (this.axisDropDownComponent.type === 'multiSelect') {
          this.isSelected = !this.isSelected;
          this.option.isSelected = this.isSelected;
          if (this.axisDropDownComponent.isNestedMultiselect) {
            this.selectNestedOptions(this.isSelected);
          }
        } else {
          this.isSelected = true;
          this.option.isSelected = true;
          this.axisDropDownComponent.deSelectOthers(this);
        }
        this.axisDropDownComponent.notifyChange(this);
      }
    }
  }

  touchedDropdownList(event) {
    this.axisDropDownComponent.isListItem = true;
    this.axisDropDownComponent.target = event.target;
    this.isSelectOptionCalled = false;
    setTimeout(() => {
      if (!this.isSelectOptionCalled) {
        if (!this.disabled && !this.isReadOnly) {
          this.selectOption(event);
        }
      }
    }, 1000);
  }

  // For nested multi select dropdown
  selectNestedOption(event: Event, child) {
    event.preventDefault();
    if (!this.isReadOnly) {
      child.isSelected = !child.isSelected;
      this.toggleParentSelect();
    } else {
      this.axisDropDownComponent['dataProviderCopy'].forEach(childElement => {
        childElement['children'].forEach(element => {
          element['isSelected'] = !element.disabled
            ? false
            : element['isSelected'];
        });
      });
      if (!child.disabled) {
        child.isSelected = true;
        this.axisDropDownComponent.notifyChange(this);
      }
    }
  }

  selectNestedOptions(parentSelect: boolean) {
    if (this.option.children) {
      this.option.children.forEach(child => {
        child.isSelected = !child.disabled ? parentSelect : child.isSelected;
      });
    }
  }

  toggleParentSelect() {
    if (!this.disabled) {
      let count = 0;
      let enabledItemsCount = 0;
      this.option.children.forEach(child => {
        if (child.isSelected) {
          count++;
        }
        if (!child.disabled) {
          enabledItemsCount++;
        }
      });
      if (count >= enabledItemsCount) {
        this.option.isSelected = true;
        this.isSelected = true;
      } else {
        this.option.isSelected = false;
        this.isSelected = false;
      }
    }
    this.axisDropDownComponent.notifyChange(this);
  }

  initNestedChildObj() {
    this.option.children.forEach(child => {
      child.isSelected = false;
    });
  }

  ngOnDestroy() {
    if (this.axisDropDownComponent.isMultiSearchSelect && this.axisDropDownComponent.dataShared) {
      const compIndex = this.axisDropDownComponent.dropdownListArray.indexOf(this);
      if (compIndex > -1) {
        this.axisDropDownComponent.dropdownListArray.splice(compIndex, 1);
      }
    }
    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detach();
    }
  }
}
